export async function defer(fn: (defer: (f: () => Promise<void> | void) => void) => Promise<void>) {
    const stack: (() => Promise<void> | void)[] = []
    try {
        await fn(f => stack.push(f))
    } finally {
        while (stack.length) {
            const cleanup = stack.pop()!
            await cleanup()
        }
    }
}